var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "variable-selector" },
    [
      _vm.visible
        ? _c(
            "modal2",
            {
              attrs: {
                title: _vm.$t("voiceagent.addVariable"),
                showFooter: false,
                xlarge: "",
              },
              on: { cancel: _vm.closeModal },
            },
            [
              _c("div", { staticClass: "variable-modal-content" }, [
                _c(
                  "div",
                  { staticClass: "variable-tabs" },
                  [
                    _c(
                      "a-radio-group",
                      {
                        attrs: { "button-style": "solid" },
                        model: {
                          value: _vm.activeTab,
                          callback: function ($$v) {
                            _vm.activeTab = $$v
                          },
                          expression: "activeTab",
                        },
                      },
                      [
                        _c("a-radio-button", { attrs: { value: "system" } }, [
                          _vm._v(_vm._s(_vm.$t("voiceagent.systemVariables"))),
                        ]),
                        _vm._v(" "),
                        _c("a-radio-button", { attrs: { value: "custom" } }, [
                          _vm._v(_vm._s(_vm.$t("voiceagent.customVariables"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.activeTab === "system"
                  ? _c(
                      "div",
                      { staticClass: "variable-list" },
                      [
                        _c(
                          "a-table",
                          {
                            attrs: {
                              dataSource: _vm.systemVariables,
                              pagination: false,
                              rowKey: "id",
                            },
                          },
                          [
                            _c("a-table-column", {
                              key: "name",
                              attrs: {
                                title: "Ad",
                                dataIndex: "name",
                                width: "250px",
                              },
                            }),
                            _vm._v(" "),
                            _c("a-table-column", {
                              key: "description",
                              attrs: {
                                title: "Açıklama",
                                dataIndex: "description",
                              },
                            }),
                            _vm._v(" "),
                            _c("a-table-column", {
                              key: "example",
                              attrs: {
                                title: "Örnek",
                                dataIndex: "example",
                                width: "200px",
                              },
                            }),
                            _vm._v(" "),
                            _c("a-table-column", {
                              key: "action",
                              attrs: { width: "100px" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (text, record) {
                                      return [
                                        _c(
                                          "supsis-button",
                                          {
                                            attrs: { primary: "", small: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.insertVariable(
                                                  record
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("voiceagent.add"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1324290719
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeTab === "custom"
                  ? _c(
                      "div",
                      { staticClass: "variable-list" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-variable-form" },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  validateStatus: _vm.customVariableError
                                    ? "error"
                                    : "",
                                  help: _vm.customVariableError,
                                },
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder:
                                      "Yeni değişken adı (örn: musteri_adi)",
                                  },
                                  on: {
                                    keypress: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.addCustomVariable.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.customVariableName,
                                    callback: function ($$v) {
                                      _vm.customVariableName = $$v
                                    },
                                    expression: "customVariableName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "supsis-button",
                              {
                                attrs: { primary: "" },
                                on: { click: _vm.addCustomVariable },
                              },
                              [_vm._v("Ekle")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.customVariables.length === 0
                          ? _c("div", { staticClass: "empty-variables" }, [
                              _c("p", [
                                _vm._v("Henüz özel değişken eklenmemiş"),
                              ]),
                            ])
                          : _c(
                              "a-table",
                              {
                                attrs: {
                                  dataSource: _vm.customVariables,
                                  pagination: false,
                                  rowKey: "id",
                                },
                              },
                              [
                                _c("a-table-column", {
                                  key: "name",
                                  attrs: {
                                    title: "Ad",
                                    dataIndex: "name",
                                    width: "250px",
                                  },
                                }),
                                _vm._v(" "),
                                _c("a-table-column", {
                                  key: "description",
                                  attrs: {
                                    title: "Açıklama",
                                    dataIndex: "description",
                                  },
                                }),
                                _vm._v(" "),
                                _c("a-table-column", {
                                  key: "action",
                                  attrs: { width: "180px" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (text, record, index) {
                                          return [
                                            _c(
                                              "supsis-button",
                                              {
                                                staticStyle: {
                                                  "margin-right": "8px",
                                                },
                                                attrs: {
                                                  primary: "",
                                                  small: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.insertVariable(
                                                      record
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Ekle")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "supsis-button",
                                              {
                                                attrs: {
                                                  danger: "",
                                                  small: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeCustomVariable(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Sil")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    508740421
                                  ),
                                }),
                              ],
                              1
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }